module.exports = __webpack_public_path__ + "img/reverse-right.b92ce080.svg";